import { InputWithSign } from '@/modules/common/components/input-with-sign';
import { IInputFieldArgs } from '@/modules/mixing/ts/rustmix-buyer.types';
import styles from './index.module.sass';
import classNames from 'classnames';
import { handleClick } from '@/modules/helpers/handler-click/index.helper';
import { createWheelHandler } from '@/modules/helpers/create-wheel-handler/index.helper';

export const HumidityInputField = ({
  data,
  setValue,
  renewTotalData,
  className,
}: IInputFieldArgs) => {
  const handleWheel = createWheelHandler(
    data,
    setValue,
    {
      field: 'humidity',
    },
    renewTotalData,
  );
  return (
    <InputWithSign
      float={true}
      inputClassName={styles.inpInner}
      className={classNames(styles.input, className)}
      prefix=""
      label="влажность"
      postfix="%"
      value={data.humidity}
      onClick={handleClick}
      onChange={(e: any) => {
        setValue &&
          setValue({
            ...data,
            humidity: e.target.value.replace(/[^0-9.]/g, ''),
          });
      }}
      onWheel={handleWheel}
      onBlur={renewTotalData}
    />
  );
};
